import { Navigate } from "react-router-dom";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { ReactNode } from "react";
import { RootState } from "../redux/store";

type PrivateRouteProps = {
  children: ReactNode;
};

const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const PrivateRoute = ({ children }: any) => {
  const isAuthenticated = useTypedSelector(
    (state) => state.auth.isAuthenticated
  );

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};
